module.exports = "<div class=\"col-middle\">\n  <div class=\"col-md-12 col-xs-12\">\n    <div class=\"text-center\">\n      <h1 class=\"error-number\">404</h1>\n      <h2>aucune page trouvée</h2>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main